module.exports = __webpack_public_path__ + "media/images/top/card-photowedding-e14d92e9790c880a7a6373c4c776845b.jpg";